module.exports = __webpack_public_path__ + "img/8.2c30ea40.jpg";